export default {"src":"/_next/static/media/Allergies.67a27679.svg","height":51,"width":51,"blurWidth":0,"blurHeight":0};